module.exports = __webpack_public_path__ + "img/eqip4.97c3fb4a.png";